import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useDocumentationButtonStyles = makeStyles(({ palette }) =>
  createStyles({
    button: {
      borderRadius: 0,
      '&:hover': {
        backgroundColor: palette.primary.light,
      },
    },
  })
);

export default useDocumentationButtonStyles;
